import { Box, Typography, useTheme } from '@mui/material';
import { isEmpty } from 'lodash';

// Components
import ExpandableBox from 'src/components/common/ExpandableBox';
import TableHorizontal from 'src/components/TableHorizontal';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';

// Utilities

const Shipper = ({ tradeDataDetail }: { tradeDataDetail: IBillOfLadingDetail }) => {
  const theme = useTheme();

  const configColumn = [
    {
      label: 'Vessel Name',
      isShow: (data: IBillOfLadingDetail) => !isEmpty(data?.transaction?.vessel_name),
      renderCell: (data: IBillOfLadingDetail) => (
        <Typography color={'text.secondary'} variant="body2">
          {renderTextOrDefault(data?.transaction?.vessel_name)}
        </Typography>
      ),
    },
  ];

  return (
    <ExpandableBox title="Shipper" openDefault={true} flex={1}>
      <Box
        padding={3}
        display="flex"
        flexDirection="column"
        bgcolor={theme.palette.background.default}
        borderRadius={`0px 0px ${theme.shape.borderRadius * 2}px ${theme.shape.borderRadius * 2}px`}
      >
        <TableHorizontal colKeyWidth={350} configColumn={configColumn} data={tradeDataDetail} />
      </Box>
    </ExpandableBox>
  );
};

export default Shipper;
